export default __webpack_public_path__ + "static/media/horse.ef838490.png";